import React from 'react';

import { FontEmphasis } from '@prisjakt/ui/text/variants';
import { HighlightedName } from '../highlighted-name';
import { ExtendSearchButton } from '../extend-search-button';

import {
  ListItem,
  SubListItem,
  ListItemButton,
  NameLabel,
  Labels,
  Wrapper,
  SearchIcon,
} from './styles-new';

import { useAppContext } from '@prisjakt/ui-app-context';

import { BrandTopCategory, Maybe } from 'src/types';
import { BaseItemProps } from './types';

type Props = BaseItemProps & {
  categories?: Maybe<BrandTopCategory>[] | null;
};

export const BrandItem = (props: Props) => {
  const {
    categories,
    id,
    onClick,
    onExtendSearch,
    order,
    query,
    selected,
    text,
  } = props;
  const { t } = useAppContext();

  return (
    <>
      <ListItem $selected={selected} order={order}>
        <ListItemButton onClick={onClick}>
          <Wrapper>
            <SearchIcon size={16} />

            <Labels>
              <NameLabel>
                <HighlightedName query={query}>{text}</HighlightedName>
              </NameLabel>
            </Labels>
          </Wrapper>

          {onExtendSearch && <ExtendSearchButton onClick={onExtendSearch} />}
        </ListItemButton>
      </ListItem>

      {categories?.map(
        category =>
          category &&
          category.path && (
            <SubListItem key={category.text} $selected={false} order={order}>
              <ListItemButton to={`${category.path}?brand=${id}`}>
                <NameLabel emphasis={FontEmphasis.MEDIUM}>
                  {t('common', 'text.in')} {category.text}
                </NameLabel>
              </ListItemButton>
            </SubListItem>
          )
      )}
    </>
  );
};
